import { h } from 'preact';
import { BaseAnnotation } from './base_annotation';
import { focusable } from 'utilities/accessibility';

export class HotlinkAnnotation extends BaseAnnotation {
    render() {
        const attrs = {
            className: this.classes,
            style: this.getElementStyles(),
            role: 'link',
            'aria-label': this.options.altText,
            ...focusable,
            ...this.dataAttrs,
            ...this.applyActions(this.actions)
        };

        return (
            <div { ...attrs }>
                {
                    this.clippable ? this.clippathMarkup : null
                }
            </div>
        );
    }

    get legacyClasses() {
        const base = [
            'popcorn-hotlink',
            'active',
            (this.props.transitionClass || '')
        ];

        return base.join(' ');
    }

    static get schemaType() {
        return 'hotlink';
    }
}